// Dados estruturados dos planos do Veritux ERP
// Fonte: decisão de precificação de 25/06/2026 (plano único Professional + Programa Pioneiro)

/** Ciclos de cobrança disponíveis */
export const CICLOS_COBRANCA = {
  MENSAL: 'mensal',
  TRIMESTRAL: 'trimestral',
  ANUAL: 'anual'
};

/** Opções de ciclo para o seletor (label, descrição, economia) */
export const opcoesCiclo = [
  {
    id: CICLOS_COBRANCA.MENSAL,
    label: 'Mensal',
    descricao: 'Cobrança mensal',
    economia: null
  },
  {
    id: CICLOS_COBRANCA.TRIMESTRAL,
    label: 'Trimestral',
    descricao: 'A cada 3 meses',
    economia: 10
  },
  {
    id: CICLOS_COBRANCA.ANUAL,
    label: 'Anual',
    descricao: 'Melhor economia',
    economia: 20
  }
];

export const planos = [
  {
    id: 'professional',
    nome: 'Professional',
    descricao: 'Plano único, com todos os módulos inclusos',
    preco: 197.00,
    precoOriginal: 297.00,
    periodo: 'mês',
    /**
     * Preços por ciclo sobre o valor vigente (R$ 197/mês): trimestral −10%, anual −20%.
     * Os descontos de ciclo NÃO se acumulam com a Oferta Pioneiro (R$ 49,90 é condição
     * mensal dos 6 primeiros meses).
     */
    precosPorCiclo: {
      mensal: { preco: 197.00, total: 197.00, periodo: 'mês', periodoLabel: 'mês' },
      trimestral: { precoPorMes: 177.30, total: 531.90, periodo: 'mês', periodoLabel: 'trimestre', economiaPercentual: 10 },
      anual: { precoPorMes: 157.60, total: 1891.20, periodo: 'mês', periodoLabel: 'ano', economiaPercentual: 20 }
    },
    /** Oferta Pioneiro: condição especial para as primeiras contratações */
    ofertaPioneiro: {
      precoPromocional: 49.90,
      mesesPromocao: 6,
      vagas: 20,
      precoAposPromocao: 197.00,
      congelamentoMeses: 12,
      textoFino: 'R$ 49,90/mês durante os 6 primeiros meses. Após o período, R$ 197/mês, com valor congelado por 12 meses. Promoção limitada às 20 primeiras contratações.'
    },
    badge: 'Programa Pioneiro — 20 vagas',
    popular: true,
    funcionalidades: [
      'Até 5 usuários',
      'Módulo Comercial (completo)',
      'Módulo Compras',
      'Módulo Estoque (completo)',
      'Módulo Financeiro (completo)',
      'Módulo Caixa',
      'Módulo Notas Fiscais',
      'Módulo PDV/Delivery',
      'Módulo Serviços',
      'NF-e, NFS-e e NFC-e ilimitadas',
      'Relatórios avançados',
      'Emissão de boletos',
      'Estoque mínimo e Curva ABC',
      'Controle de comissões',
      'Faturamento em lote',
      'Suporte prioritário',
      'Treinamento inicial',
      'Dashboard avançado',
      'Relatórios personalizados',
    ],
    limiteUsuarios: 5,
    // Único limite definido na decisão de 25/06 é o de usuários; NF-e/NFS-e/NFC-e são ilimitadas.
    limiteNFe: null,
    limiteProdutos: null,
    limiteFiliais: null,
    limiteTransacoes: null,
    modulosIncluidos: ['comercial', 'compras', 'estoque', 'financeiro', 'caixa', 'notas-fiscais', 'pdv-delivery', 'servicos'],
    suporte: 'Prioritário',
    integracoes: false,
    api: false,
    treinamento: 'Inicial',
    whatsappMessage: 'Olá! Gostaria de testar o plano Professional do Veritux ERP gratuitamente por 15 dias.'
  }
];

// Preços adicionais (valores NÃO cobertos pela decisão de 25/06 — validar antes de exibir publicamente)
export const precosAdicionais = {
  usuarioAdicional: 80,
  migracaoDados: {
    basica: 1000,
    intermediaria: 2000,
    avancada: 3000
  },
  treinamentoAdicional: 500
};

// Benefícios comuns a todos os planos
export const beneficiosComuns = [
  'Teste grátis de 15 dias',
  'Sem taxa de setup',
  'Cancelamento a qualquer momento',
  'Atualizações e novas funcionalidades inclusas',
  'Seus dados ficam no seu computador, sob seu controle'
];

// Oferta especial para primeiros clientes
export const ofertaEspecial = {
  ativa: true,
  titulo: 'Programa Pioneiro — 20 vagas',
  descricao: 'Para as 20 primeiras empresas que contratarem',
  beneficios: [
    'R$ 49,90/mês nos 6 primeiros meses',
    'Depois R$ 197/mês, congelado por 12 meses',
    '15 dias grátis, sem cartão',
    'Treinamento inicial incluso'
  ],
  vagas: 20,
  validoAte: 'Limitado às 20 primeiras contratações'
};